// @flow
// This module is written in CJS so that it can be used on the server-side
// without transpiling.

const COMPANIES_PAGES_MOUNT_POINT = 'companies';
const HELPDOCS_MOUNT_POINT = 'help';
const PLATFORM_CONTENT_SITE_MOUNT_POINT = 'platform';
const PLATFORM_BOUNCER_MOUNT_POINT = 'platform/bouncer';
const PRICING_PAGES_MOUNT_POINT = 'pricing';
const PRIVACY_PAGE_MOUNT_POINT = 'privacy';
const SECURITY_MOUNT_POINT = 'security';

const ZAPIER_ADMIN_URL = (() => {
  const PROD = 'https://admin.zapier.com';
  const DEV = 'http://localhost:8000';
  return process.env.NODE_ENV === 'production' ? PROD : DEV;
})();

const DEVELOPER_PLATFORM_DOC_URL = 'https://platform.zapier.com';

const X_FRAME_EXEMPT = {
  // Use if the route is safe even in a malicious embed (we will skip checking if the
  // embedder is permitted). This is dangerous, and you should never have to use this.
  // Use EXEMPT instead.
  DANGEROUSLY_ALWAYS: 'always',
  // use if the route is permitted to be embedded. we will still check
  // if the embedder is permitted (whitelisted)
  EXEMPT: 'exempt',
};

module.exports = {
  PLATFORM_BOUNCER_MOUNT_POINT,
  COMPANIES_PAGES_MOUNT_POINT,
  DEVELOPER_PLATFORM_DOC_URL,
  HELPDOCS_MOUNT_POINT,
  PLATFORM_CONTENT_SITE_MOUNT_POINT,
  PRICING_PAGES_MOUNT_POINT,
  PRIVACY_PAGE_MOUNT_POINT,
  SECURITY_MOUNT_POINT,
  X_FRAME_EXEMPT,
  ZAPIER_ADMIN_URL,
};
